import React, { useState } from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Textarea,
} from '@nextui-org/react';
import { addCommentToTask } from 'common/src/api/comments';
import { toast } from 'react-toastify';

interface ModalAddCommentProps {
  isOpen: boolean;
  onClose: () => void;
  taskId: string;
  userId: string;
  onCommentAdded: () => void;
}

export const ModalAddComment: React.FC<ModalAddCommentProps> = ({
  isOpen,
  onClose,
  taskId,
  userId,
  onCommentAdded,
}) => {
  const [comment, setComment] = useState('');

  const handleAddComment = async () => {
    try {
      await addCommentToTask(taskId, userId, comment);
      toast.success('Comment added successfully');
      onCommentAdded();
      onClose();
    } catch (error) {
      toast.error('Failed to add comment');
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        <ModalHeader>Add Comment</ModalHeader>
        <ModalBody>
          <Textarea
            label="Comment"
            placeholder="Enter your comment here"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="danger" variant="light" onPress={onClose}>
            Cancel
          </Button>
          <Button color="primary" onPress={handleAddComment}>
            Add Comment
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};